import 'css/app.scss';

import TermsLayout from './components/TermsLayout';

export default (): React.ReactNode => TermsLayout;
